module.exports = __webpack_public_path__ + "img/1569522188.efe8a943.jpg";